const Skeleton = () => {
  return (
    <section className="pb-24">
      <section className="my-4">
        <div className="mt-4 h-10 w-full bg-gray-100"></div>
        <div className="my-2 h-[1px] w-full bg-gray-100"></div>
        <div className="h-10 w-full bg-gray-100"></div>
      </section>
      <div className="grid grid-cols-2 gap-3 px-4 pt-8 md:grid-cols-3 md:gap-6 md:px-0 xl:grid-cols-4">
        {[...Array(8)].map((_, index) => (
          <div key={index} className="animate-pulse bg-gray-100 p-4 shadow-sm">
            <div className="h-40 bg-gray-200"></div>
            <div className="mt-4 space-y-2">
              <div className="h-4 w-3/4 bg-gray-200"></div>
              <div className="h-4 w-1/2 bg-gray-200"></div>
            </div>
            <div className="mt-4 h-6 w-1/3 bg-gray-200"></div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Skeleton;
